import { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import { getLanBase } from '../lib/lanStorage';

/**
 * Small green "LAN直結" badge shown in the header when the browser has
 * detected direct reachability of the NAS agent. Silently absent when
 * on WAN — no distraction for remote users.
 *
 * Re-renders whenever `lan-base-changed` is dispatched (see lanStorage.js).
 */
export function LanDirectBadge() {
  const [base, setBase] = useState(getLanBase());

  useEffect(() => {
    const handler = () => setBase(getLanBase());
    window.addEventListener('lan-base-changed', handler);
    return () => window.removeEventListener('lan-base-changed', handler);
  }, []);

  if (!base) return null;

  // Tooltip shows the actual base URL for tech-savvy users who want to verify
  const host = (() => { try { return new URL(base).host; } catch { return base; } })();

  return (
    <span
      data-testid="lan-direct-badge"
      title={`LAN 直結ダウンロード有効: ${host}`}
      className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide rounded-full bg-emerald-100 text-emerald-800 border border-emerald-300"
    >
      <Zap className="w-3 h-3" />
      LAN直結
    </span>
  );
}

export default LanDirectBadge;
